var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMedication = function SvgMedication(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 42 42"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    stroke: "transparent",
    d: "M7.986 24.638a6.524 6.524 0 0 0 0 9.226l.001.001a6.524 6.524 0 0 0 9.226 0l7.69-7.69-9.227-9.227zm25.88-7.425-7.69 7.69-9.228-9.228 7.69-7.69a6.524 6.524 0 0 1 9.226 0l.001.002a6.524 6.524 0 0 1 0 9.226Zm-10.5-10.5-8.303 8.302-.048.048-8.302 8.302a8.324 8.324 0 0 0 0 11.772h.001a8.324 8.324 0 0 0 11.772 0l16.652-16.651a8.324 8.324 0 0 0 0-11.772l-.001-.001a8.324 8.324 0 0 0-11.772 0Zm7.383 8.286a.9.9 0 1 0-1.273-1.273l-3.937 3.937a.9.9 0 0 0 1.272 1.273z",
    clipRule: "evenodd"
  })));
};
export default SvgMedication;